import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
import classNames from "classnames";

class Paragraph extends React.Component {
  render() {
    const {
      mutted,
      strong,
      slim,
      size,
      margin,
      text,
      upper,
      lower,
      className,
      style,
      children,
      ...extraProps
    } = this.props;

    const paragraphClasses = classNames(
      "p",
      {
        mutted: mutted,
        strong: strong,
        slim: slim,
        [size]: size,
        [`margin-${margin}`]: margin,
        [`text-${text}`]: text,
        "text-upper": upper,
        "text-lower": lower
      },
      className
    );

    return React.createElement(
      "p",
      {
        className: paragraphClasses,
        style,
        ...(extraProps || {})
      },
      children
    );
  }
}

Paragraph.defaultProps = {
  size: null,
  margin: false,
  mutted: false,
  strong: false,
  slim: false,
  text: false,
  upper: false,
  lower: false,
  className: "",
  style: {},
  children: null
};

Paragraph.propTypes = {
  size: PropTypes.oneOf(["small", "x-small"]),
  margin: PropTypes.oneOf([false, "no", "no-top", "no-bottom"]),
  mutted: PropTypes.bool,
  strong: PropTypes.bool,
  slim: PropTypes.bool,
  text: PropTypes.oneOf([false, "left", "center", "right"]),
  upper: PropTypes.bool,
  lower: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  children: PropTypes.node
};

export default Paragraph;
